import React from 'react'
import DropdownField from '../../formFields/dropdownField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <DropdownField {...fieldProps} />
))
